<template>
  <div class="cpt-intelligent">
    <div :class="$utils.isMobile() ? 'intelligent-m' : 'intelligent'">
      <div class="title-en tit-en" v-if="$i18n.locale == 'zh-CN'">{{ intelligentData.titleEn }}</div>
      <div class="title tit">{{ intelligentData.title }}</div>
      <div class="text-box">{{ intelligentData.text }}</div>
      <div class="content">
        <div class="model">
          <div :class="$i18n.locale == 'en-US' ? 'content-title-en' : 'content-title'">{{ intelligentData.model.title }}</div>
          <div :class="$i18n.locale == 'en-US' ? 'text-box-en' : 'text-box'">{{ intelligentData.model.text }}</div>
          <div class="list">
            <div class="item" v-for="item in intelligentData.model.list" :key="item.id">
              <img class="img" :src="item.img" alt="">
              <div class="item-box">
                <div :class="$i18n.locale == 'en-US' ? 'item-title-en' : 'item-title'">{{ item.title }}</div>
                <div :class="$i18n.locale == 'en-US' ? 'item-txt-en' : 'item-txt'">{{ item.text }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="strategy">
          <div :class="$i18n.locale == 'en-US' ? 'content-title-en' : 'content-title'">{{ intelligentData.strategy.title }}</div>
          <div :class="$i18n.locale == 'en-US' ? 'text-box-en' : 'text-box'">{{ intelligentData.strategy.text }}</div>
          <div class="list">
            <div :class="$i18n.locale == 'en-US' ? 'item-name-en' : 'item-name'" v-for="item in intelligentData.strategy.list" :key="item.id">
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cpt-intelligent',
  data() {
    return {
      intelligentData: this._contentData.intelligentData
    }
  },

  methods: {

  },
}

</script>

<style lang='scss' scoped>
.cpt-intelligent{
//  width: auto;
  .intelligent{
    width: 100%;
    // height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 50px;
    .tit-en{
      color: rgba(51, 51, 51, 0.3);
      // text-align: center;
    }
    .tit{
      color: rgba(51, 51, 51, 1);
      // text-align: center;
    }
    .text-box{
      color: #666;
      font-size: 26px;
      // font-family: MiSans-Regular;
    }
    .text-box-en{
      color: #666;
      font-size: 24px;
      // font-family: MiSans-Regular;
    }
    .content{
      display: flex;
      justify-content: space-between;
      width: 1200px;
      padding: 30px 0;
      .content-title{
        font-size: 30px;
        color: #333;
        // font-family: MiSans-Demibold;
      }
      .content-title-en{
        font-size: 26px;
        color: #333;
        // font-family: MiSans-Demibold;
      }
      .model{
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 48%;
        .list{
          display: flex;
          height: 100%;
          margin-top: 30px;
          .item{
            width: 100%;
            height: 100%;
            margin: 0 10px;
            position: relative;
            display: flex;
            .img{
              width: 280px;
            }
            .item-box{
              position: absolute;
              top: 0;
              left: 0;
              padding: 5px 25px;
              letter-spacing: 1px;
              .item-title{
                font-size: 22px;
                color: #FFF;
                // font-family: MiSans-Medium;
                padding: 20px 0;
              }
              .item-title-en{
                font-size: 18px;
                color: #FFF;
                // font-family: MiSans-Medium;
                padding: 20px 0;
              }
              .item-txt{
                font-size: 16px;
                color: #FFF;
                // font-family: MiSans-Normal;
                padding: 20px 0;
                border-top: 1px solid #fff;
              }
              .item-txt-en{
                font-size: 14px;
                color: #FFF;
                // font-family: MiSans-Normal;
                padding: 20px 0;
                border-top: 1px solid #fff;
              }
            }
          }
        }
      }
      .strategy{
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 49%;
        .list{
          display: flex;
          flex-wrap: wrap;
          justify-content: space-around;
          align-content: space-between;
          height: 100%;
          margin-top: 30px;
          .item-name{
            width: 280px;
            height: 110px;
            border: 1px solid;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            font-size: 22px;
            color: #666;
            // font-family: MiSans-Medium;
          }
          .item-name-en{
            width: 280px;
            height: 110px;
            border: 1px solid;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            font-size: 18px;
            color: #666;
            // font-family: MiSans-Medium;
            text-align: center;
            padding: 0 20px;
            box-sizing: border-box;
          }
        }
      }
    }
  }
  .intelligent-m{
    // width: 100%;
    // height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 15px;
    .tit-en{
      color: rgba(51, 51, 51, 0.3);
      text-align: center;
    }
    .tit{
      color: rgba(51, 51, 51, 1);
      text-align: center;
    }
    .text-box{
      color: #666;
      font-size: 10px;
      // font-family: MiSans-Regular;
      text-align: center;
    }
    .text-box-en{
      color: #666;
      font-size: 10px;
      // font-family: MiSans-Regular;
      text-align: center;
    }
    .content{
      display: flex;
      justify-content: space-between;
      // width: 1200px;
      padding: 20px 0;
      letter-spacing: normal;
      .content-title{
        font-size: 10px;
        color: #333;
        // font-family: MiSans-Medium;
        padding: 5px 0;
        text-align: center;
      }
      .content-title-en{
        font-size: 12px;
        color: #333;
        // font-family: MiSans-Medium;
        padding: 5px 10px;
        text-align: center;
      }
      .model{
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 48%;
        .list{
          display: flex;
          flex-direction: column;
          // height: 100%;
          margin-top: 10px;
          .item{
            width: 100%;
            // height: 100%;
            // margin: 5px 0;
            position: relative;
            display: flex;
            &:last-child{
              margin-top: 10px;
            }
            .img{
              width: 170px;
              height: 120px;
              overflow: hidden;
            }
            .item-box{
              position: absolute;
              top: 0;
              left: 0;
              padding: 5px 10px;
              letter-spacing: 1px;
              .item-title{
                font-size: 12px;
                color: #FFF;
                // font-family: MiSans-Medium;
                padding: 10px 0;
              }
              .item-title-en{
                font-size: 8px;
                color: #FFF;
                // font-family: MiSans-Medium;
                padding: 10px 0;
              }
              .item-txt{
                font-size: 6px;
                color: #FFF;
                // font-family: MiSans-Normal;
                padding: 10px 0;
                border-top: 1px solid #fff;
              }
              .item-txt-en{
                font-size: 6px;
                color: #FFF;
                // font-family: MiSans-Normal;
                padding: 10px 0;
                border-top: 1px solid #fff;
              }
            }
          }
        }
      }
      .strategy{
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 49%;
        .list{
          display: flex;
          flex-wrap: wrap;
          justify-content: space-around;
          align-content: space-between;
          height: 100%;
          margin-top: 10px;
          .item-name{
            width: 170px;
            height: 35px;
            border: 1px solid;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            font-size: 12px;
            color: #666;
            // font-family: MiSans-Medium;
          }
          .item-name-en{
            width: 170px;
            height: 35px;
            border: 1px solid;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            font-size: 10px;
            color: #666;
            // font-family: MiSans-Medium;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>